
<template>
  <v-card style="border-radius:12px">
    <v-card-title primary-title>
      <div class="headline mb-0">Endereço</div>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-container>
        <v-form v-model="valid_address" lazy-validation ref="formAddress">
          <v-text-field :rules="[rules.required]" v-model="address.zip" v-mask="mask_zip" @input="fetchZip(address.zip)" prepend-icon="mdi-map-marker" label="CEP"></v-text-field>
          <v-text-field :rules="[rules.required]" v-model="address.street" prepend-icon="mdi-routes" label="Rua/Av"></v-text-field>
          <v-text-field :rules="[rules.required]" v-model="address.number" prepend-icon="mdi-information" label="Número"></v-text-field>
          <v-text-field v-model="address.complement" prepend-icon="mdi-information" label="Complemento"></v-text-field>
          <v-text-field :rules="[rules.required]" v-model="address.neighborhood" prepend-icon="mdi-home-city" label="Bairro"></v-text-field>
          <v-text-field :rules="[rules.required]" v-model="address.city" prepend-icon="mdi-city" label="Cidade"></v-text-field>
          <v-text-field :rules="[rules.required]" v-model="address.state" prepend-icon="mdi-map" label="Estado"></v-text-field>
          <!-- <span v-show="false">{{full_address}}</span> -->
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn rounded text color="error" @click="cancelAddress()"> <v-icon left>mdi-close</v-icon> Fechar</v-btn>
      <v-btn rounded text color="success" @click="submitAddress()"> <v-icon left>mdi-content-save</v-icon> Salvar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'
import axios from 'axios'
import cep from 'cep-promise'

export default {
  directives: {
    mask,
  },
  props: {
    address: {
      type: Object,
      default: () => {return {zip:null, street:null, number:null, complement:null, neighborhood:null, city:null, state:null}},
    },
  },
  data() {
    return {
      mask_zip:"##.###-###",
      valid_address: true,
      rules: {
        required: v => !!v || 'Campo é necessário',
        email: v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail deve ser válido',
        cpf: v => (v && v.length == 11) || 'CPF deve ser completo',
      },
      address_copy: {...this.address}
    }
  },
  methods: {
    genFullAddress(address){
      let full = `${address.street}, ${address.number}, ${address.neighborhood}, ${address.zip}, ${address.city} - ${address.state}` 
      return full
    },
    cancelAddress() {
      this.$emit('address-sent', {...this.address_copy, full_address: this.genFullAddress(this.address_copy)})
    },
    submitAddress() {
      if (this.$refs.formAddress.validate()){
        this.$emit('address-sent', {...this.address, full_address: this.genFullAddress(this.address)})
      }
    },
    fetchZip(zip){
      console.log({zip});
      
      if(/^[0-9]{8}$/.test(zip.replace(/[.-]/g,''))){
        // this.$http.get("https://viacep.com.br/ws/" + zip + "/json/")
          // .then(response => response.data)
        cep(zip.replace(/[.-]/g,''))
          .then(endereco => {
            // console.log({endereco});
            
            // if(!endereco.erro){
              this.address= {...this.address, ...endereco}
              // let {street,neighborhood,city,state} = endereco
              // this.address.street = street
              // this.address.neighborhood = neighborhood
              // this.address.city = city
              // this.address.state = state
            // }
          }).catch(function(error) {
            console.log(error);
          })
      }
      else {
        // console.log('erro no cep');
      }
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    // full_address() {
    //   let full = `${this.address.street}, ${this.address.number}, ${this.address.neighborhood}, ${this.address.zip}, ${this.address.city} - ${this.address.state}` 
    //   this.address = {...this.address, full_address: full}
    //   return full
    // },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    'address.zip'(nv,ov) {
      if (nv){
        // this.fetchZip(nv.replace(/[.-]/g,''))
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>